import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { ApiError, Tag } from 'utils/types';
import { Meta } from 'utils/types';

import c from '../utils/constants';

interface Result {
  data: Tag[];
  meta: Meta;
}

export default function useGetTags(params?: Record<string, any>) {
  const { state } = useProvider();
  const args = state;
  const { accountId, accountUserId } = useAdminParams();

  return useQuery<Result, ApiError>({
    queryKey: [c.TAGS, params],
    queryFn: async () => {
      const api = new Api(args);

      const data = await api.get(
        await withAcl({
          account: {
            url: 'api/v1/tags',
            params,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/tags`,
            params,
          },
        }),
      );

      return data;
    },
  });
}
